// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".valid-entry[data-v-154cb544] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(104, 211, 145, var(--tw-bg-opacity));\n}\n.invalid-entry[data-v-154cb544] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(252, 129, 129, var(--tw-bg-opacity));\n}\nlabel[data-v-154cb544] {\n  pointer-events: none;\n}\ninput[data-v-154cb544]:-webkit-autofill {\n  background-color: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
